import { Link } from "react-router-dom";
import {
  ChevronRight,
  Mail,
  Phone,
} from "lucide-react";
import SettingsLayout from "./SettingsLayout";

const faqs = [
  { q: "Profile not verified?", a: "Wait for admin review or update your profile from the dashboard." },
  { q: "Cannot see matches?", a: "Check that privacy isn't set to hidden and your gender preferences are complete." },
  { q: "Wrong phone number?", a: "Contact support — OTP login is tied to your registered mobile." },
];

export default function SupportSettings() {
  return (
    <SettingsLayout
      title="Help & Support"
      description="Find answers and ways to reach the Karanki team."
    >
      <Link
        to="/contact-us"
        className="group flex items-center gap-3 rounded-2xl border border-sand-200 bg-white px-4 py-3.5 transition hover:border-brand-200 hover:bg-sand-50/50 sm:px-5"
      >
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-700">
          <Mail size={17} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-ink-800">Contact support</p>
          <p className="mt-0.5 text-[11.5px] leading-4 text-ink-500">Questions, feedback, or membership help</p>
        </div>
        <ChevronRight size={16} className="shrink-0 text-ink-300 transition group-hover:translate-x-0.5 group-hover:text-brand-600" />
      </Link>

      <section className="mt-4 overflow-hidden rounded-3xl border border-sand-200 bg-white shadow-sm">
        <div className="px-4 pb-3 pt-4 sm:px-5 sm:pt-5">
          <h2 className="text-[15px] font-semibold text-ink-800">Common questions</h2>
          <p className="mt-1 text-[12px] text-ink-500">Quick answers to common account questions.</p>
        </div>
        <div className="px-4 pb-1 sm:px-5">
          {faqs.map((f) => (
            <details
              key={f.q}
              className="group border-t border-sand-100 py-3.5"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-[13px] font-semibold text-ink-800 marker:content-none">
                <span>{f.q}</span>
                <ChevronRight size={15} className="shrink-0 text-ink-400 transition group-open:rotate-90 group-open:text-brand-600" />
              </summary>
              <p className="mt-2 pr-6 text-[12px] leading-5 text-ink-500">{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      <a
        href="tel:+919912349925"
        className="mt-4 flex items-center gap-3 rounded-3xl border border-sand-200 bg-white p-4 shadow-sm transition hover:border-brand-200 sm:px-5"
      >
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
          <Phone size={17} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-ink-800">Call our support team</p>
          <p className="mt-0.5 text-[11.5px] leading-4 text-ink-500">Available Mon–Sat, 9am–7pm IST</p>
        </div>
        <span className="shrink-0 text-[12px] font-semibold text-brand-700">Call</span>
      </a>
    </SettingsLayout>
  );
}
